export default __webpack_public_path__ + "static/media/ennj-artwork-1080x675.e09f3447.png";